const ConditionalRender = ({ predicate, children, fallback }) => predicate ? children : fallback || null;
export default ConditionalRender;
//# sourceMappingURL=ConditionalRender.js.map